import { Table, TableBody, TableContainer } from '@mui/material';
import { ScheduleEntry } from '../../domain/ScheduleEntry';
import { ScheduleWeek } from '../../domain/ScheduleWeek';
import { prepareAssigned } from './utils/scheduleUtils';
import ScheduleTableEntry from './schedule-table/ScheduleTableEntry';
import { ScheduleView } from './ScheduleContent';

interface Props {
    week?: ScheduleWeek;
    entries: ScheduleEntry[];
    editable?: boolean;
    view: ScheduleView;
    onEntryUpdate?: (entry: ScheduleEntry) => void;
    onEntryEdit?: (entry: ScheduleEntry) => void;
    onPublisherScheduleHistory?: (entry: ScheduleEntry) => void;
    onEntryAssignmentHistory?: (entry: ScheduleEntry) => void;
    onEntrySendNotification?: (entry: ScheduleEntry) => void;
    onEntryDownload?: (entry: ScheduleEntry) => void;
    onEntryAutoArrange?: (entry: ScheduleEntry) => void;
}

const ScheduleWorkdayTab = (props: Props) => {
    const assigned = prepareAssigned(props.entries);
    return (
        <>
            <TableContainer>
                <Table size="small">
                    <TableBody>
                        <ScheduleTableEntry
                            name="intro"
                            week={props.week}
                            entries={props.entries.filter(entry => entry.subType === "intro")}
                            assigned={assigned}
                            editable={props.editable}
                            view={props.view}
                            onEntryUpdate={props.onEntryUpdate}
                            onEntryEdit={props.onEntryEdit}
                            onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                            onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                            onEntrySendNotification={props.onEntrySendNotification}
                            onEntryAutoArrange={props.onEntryAutoArrange}
                        />
                        <ScheduleTableEntry
                            name="treasures"
                            week={props.week}
                            entries={props.entries.filter(entry => entry.subType === "treasures")}
                            assigned={assigned}
                            editable={props.editable}
                            view={props.view}
                            onEntryUpdate={props.onEntryUpdate}
                            onEntryEdit={props.onEntryEdit}
                            onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                            onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                            onEntrySendNotification={props.onEntrySendNotification}
                            onEntryDownload={props.onEntryDownload}
                            onEntryAutoArrange={props.onEntryAutoArrange}
                        />
                        <ScheduleTableEntry
                            name="apply-yourself"
                            week={props.week}
                            entries={props.entries.filter(entry => entry.subType === "apply-yourself")}
                            assigned={assigned}
                            editable={props.editable}
                            view={props.view}
                            onEntryUpdate={props.onEntryUpdate}
                            onEntryEdit={props.onEntryEdit}
                            onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                            onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                            onEntrySendNotification={props.onEntrySendNotification}
                            onEntryDownload={props.onEntryDownload}
                            onEntryAutoArrange={props.onEntryAutoArrange}
                        />
                        <ScheduleTableEntry
                            name="living-as-christians"
                            week={props.week}
                            entries={props.entries.filter(entry => entry.subType === "living-as-christians")}
                            assigned={assigned}
                            editable={props.editable}
                            view={props.view}
                            onEntryUpdate={props.onEntryUpdate}
                            onEntryEdit={props.onEntryEdit}
                            onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                            onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                            onEntrySendNotification={props.onEntrySendNotification}
                            onEntryAutoArrange={props.onEntryAutoArrange}
                        />
                        <ScheduleTableEntry
                            name="assignment"
                            week={props.week}
                            entries={props.entries.filter(entry => entry.subType === "assignment")}
                            assigned={assigned}
                            editable={props.editable}
                            view={props.view}
                            onEntryUpdate={props.onEntryUpdate}
                            onEntryEdit={props.onEntryEdit}
                            onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                            onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                            onEntrySendNotification={props.onEntrySendNotification}
                            onEntryAutoArrange={props.onEntryAutoArrange}
                        />
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default ScheduleWorkdayTab;